export const FEATURED_ARTISTS_REDUCER_KEY = 'feturedArtists';

export const GET_FEATURED_ARTIST = `${FEATURED_ARTISTS_REDUCER_KEY}/GET_FEATURED_ARTIST`;
export const GET_FEATURED_ARTIST_SUCCESS = `${FEATURED_ARTISTS_REDUCER_KEY}/GET_FEATURED_ARTIST_SUCCESS`;
export const GET_FEATURED_ARTIST_FAILURE = `${FEATURED_ARTISTS_REDUCER_KEY}/GET_FEATURED_ARTIST_FAILURE`;
